import { render } from "./Index.vue?vue&type=template&id=e2f407bc&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=e2f407bc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e2f407bc"

export default script